import { Option, LocationArray, AgencyArray, ContactArray } from '../types';
import { idFromSlug } from '../../../utils';

enum categories {
  locations = 'Suburb',
  agencies = 'Agency',
  agents = 'Agent',
}

export const buildLocations = (locationArray: LocationArray): Option[] =>
  locationArray.map((location) => ({
    category: categories.locations,
    label: location.displayName,
    value: location.nameSlug,
    url: undefined,
    redirectToURL: false,
    avatar: undefined,
    suburbName: location.name ?? undefined,
    state: location.state ?? undefined,
    postcode: location.postcode ?? undefined,
  }));

export const buildAgencies = (agencyArray: AgencyArray): Option[] =>
  agencyArray.map((agency) => ({
    category: categories.agencies,
    label: agency.agencyName,
    value: agency.profileUrl,
    url: `/real-estate-agencies/${agency.profileUrl}`,
    redirectToURL: true,
    avatar: agency.logo?.url ?? undefined,
    backgroundColour: agency.backgroundColour ?? undefined,
    agencyId: idFromSlug(agency.profileUrl),
    agencyName: agency.agencyName,
    suburbName: agency.suburb ?? undefined,
    state: agency.state ?? undefined,
    postcode: agency.postcode ?? undefined,
  }));

export const buildContacts = (contactArray: ContactArray): Option[] =>
  contactArray.map((contact) => ({
    category: categories.agents,
    label: contact.name,
    value: contact.profileUrl, // with the duplicate agent issue there are contacts with the same id value
    url: `/real-estate-agent/${contact.profileUrl}${contact.profileUrl?.endsWith('/') ? '' : '/'}`,
    redirectToURL: true,
    // Strip low resolution fallback avatars from Agency API
    avatar: contact.thumbnail?.includes('noAgentPhoto')
      ? undefined
      : contact.thumbnail,
    contactId: contact.contactId,
    agencyId: contact.agencyId ?? undefined,
    agencyName: contact.agencyName ?? undefined,
    suburbName: contact.suburb ?? undefined,
    state: contact.state ?? undefined,
  }));
